export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          有黑料线索？欢迎投稿与合作
        </p>
        <div className="bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-5 bg-background-100 rounded-lg border border-background-200/60">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-500/15 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-400"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-2">投稿爆料</h3>
              <p className="text-xs text-foreground-400 leading-relaxed">
                如果你有独家黑料线索或瓜田见闻，欢迎通过投稿渠道提交，编辑团队将认真评估每一条来稿。
              </p>
              <p className="text-xs text-primary-400 mt-3 font-medium">tips@heiliao.com</p>
            </div>
            <div className="text-center p-5 bg-background-100 rounded-lg border border-background-200/60">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-500/15 flex items-center justify-center">
                <i className="ri-shake-hands-line text-xl text-accent-400"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-2">商务合作</h3>
              <p className="text-xs text-foreground-400 leading-relaxed">
                欢迎品牌方、媒体机构与我们洽谈合作，共同打造更优质的吃瓜内容生态和传播渠道。
              </p>
              <p className="text-xs text-accent-400 mt-3 font-medium">biz@heiliao.com</p>
            </div>
            <div className="text-center p-5 bg-background-100 rounded-lg border border-background-200/60">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-500/15 flex items-center justify-center">
                <i className="ri-question-answer-line text-xl text-primary-400"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-2">内容反馈</h3>
              <p className="text-xs text-foreground-400 leading-relaxed">
                对黑料入口的内容有任何意见或建议，欢迎随时与我们沟通，你的反馈是我们进步的动力。
              </p>
              <p className="text-xs text-primary-400 mt-3 font-medium">feedback@heiliao.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}